import { ConvertedTime, convertMillisecondsToTime } from "@utils/format/time";

type TimeMs = number | undefined

type ComparedTime = {
    fact: ConvertedTime
    plan: ConvertedTime
    isExceed: boolean
}

type CompareTimeForExceed = (factMs: TimeMs, planMs: TimeMs) => ComparedTime

export const getConvertedPeriodAndExceedInfo: CompareTimeForExceed = (factMs, planMs) => {
    const convertedPlan = convertMillisecondsToTime(planMs)
    const convertedFact = convertMillisecondsToTime(factMs)
    const isExceed =
        Boolean(planMs) && convertedFact.hours * 60 + convertedFact.minutes > convertedPlan.hours * 60 + convertedPlan.minutes

    return {
        fact: convertedFact,
        plan: convertedPlan,
        isExceed
    }
}